/** Shared styles for learner home cards. */
import { useState } from 'react';
import type { CSSProperties } from 'react';

export function useHover(): [boolean, { onMouseEnter: () => void; onMouseLeave: () => void }] {
  const [h, setH] = useState(false);
  return [h, { onMouseEnter: () => setH(true), onMouseLeave: () => setH(false) }];
}

export const SURFACE: CSSProperties = {
  borderRadius: 'var(--radius-lg)',
  background: 'var(--color-surface)',
  backdropFilter: 'blur(16px) saturate(1.3)',
  WebkitBackdropFilter: 'blur(16px) saturate(1.3)',
  border: '1px solid var(--color-surface-border)',
  boxShadow: 'var(--surface-shadow-glass-rest)',
};

export const SHADOW_REST = 'var(--surface-shadow-glass-rest)';
export const SHADOW_HOVER = 'var(--surface-shadow-glass-hover)';
export const HOVER_BORDER_REST = 'var(--color-surface-border)';
export const HOVER_BORDER_HOVER = 'var(--surface-border-hover)';
export const TRACK = 'var(--color-surface-track)';

export const LABEL_STYLE: CSSProperties = {
  fontSize: 'var(--text-xs)',
  fontWeight: 'var(--weight-semibold)',
  color: 'var(--color-text-muted)',
  letterSpacing: 'var(--tracking-eyebrow)',
  textTransform: 'uppercase',
};

export const SECTION_LINK_STYLE: CSSProperties = {
  fontSize: 'var(--type-meta-size)',
  fontWeight: 'var(--weight-medium)',
  color: 'var(--color-accent-text)',
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
};

export const eyebrow: CSSProperties = {
  fontSize: 'var(--type-eyebrow-size)',
  fontWeight: 'var(--type-eyebrow-weight)',
  letterSpacing: 'var(--type-eyebrow-tracking)',
  lineHeight: 'var(--type-eyebrow-leading)',
  textTransform: 'uppercase',
  color: 'var(--color-text-muted)',
};

export const title: CSSProperties = {
  fontSize: 'var(--type-list-title-size)',
  fontWeight: 'var(--type-list-title-weight)',
  letterSpacing: 'var(--type-list-title-tracking)',
  lineHeight: 'var(--type-list-title-leading)',
  color: 'var(--color-text)',
};

export const body: CSSProperties = {
  fontSize: 'var(--type-body-size)',
  fontWeight: 'var(--type-body-weight)',
  letterSpacing: 'var(--type-body-tracking)',
  lineHeight: 'var(--type-body-leading)',
  color: 'var(--color-text-secondary)',
};

export const meta: CSSProperties = {
  fontSize: 'var(--type-meta-size)',
  fontWeight: 'var(--type-meta-weight)',
  letterSpacing: 'var(--type-meta-tracking)',
  lineHeight: 'var(--type-meta-leading)',
  color: 'var(--color-text-muted)',
};

export const pageTitle: CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontSize: 'var(--type-hero-title-size)',
  fontWeight: 'var(--type-hero-title-weight)',
  letterSpacing: 'var(--type-hero-title-tracking)',
  lineHeight: 'var(--type-hero-title-leading)',
  color: 'var(--color-text)',
};

export const sectionHeading: CSSProperties = {
  fontFamily: 'var(--font-display)',
  fontSize: 'var(--type-section-title-size)',
  fontWeight: 'var(--type-section-title-weight)',
  letterSpacing: 'var(--type-section-title-tracking)',
  lineHeight: 'var(--type-section-title-leading)',
  color: 'var(--color-text)',
};

export const helperText: CSSProperties = {
  fontSize: 'var(--type-meta-size)',
  fontWeight: 'var(--weight-normal)',
  letterSpacing: 'var(--tracking-normal)',
  lineHeight: 'var(--leading-normal)',
  color: 'var(--color-text-secondary)',
};

export const utilityText: CSSProperties = {
  fontSize: 'var(--type-meta-size)',
  fontWeight: 'var(--weight-medium)',
  letterSpacing: 'var(--tracking-normal)',
  color: 'var(--color-text-secondary)',
};

export const buttonLabel: CSSProperties = {
  fontWeight: 'var(--weight-semibold)',
  letterSpacing: 'var(--tracking-normal)',
};
